export default __webpack_public_path__ + "static/media/gallery_13.3a4d67bf.jpg";